import { allotmentSummaryConstants } from '../../_constants';

const initialState = { getAllotmentSummaryLoading: true, data: '', error: false };

export function getAllotmentSummary(state = initialState, action) {
    
    switch (action.type) {
        case allotmentSummaryConstants.REQUEST_ALLOTMENT_SUMMARY:
            return {
                getAllotmentSummaryLoading: true,
                data: '',
                error: false
            };
        case allotmentSummaryConstants.RECEIVE_ALLOTMENT_SUMMARY:
            return {
                getAllotmentSummaryLoading: false,
                data: action.getAllotmentSummary,
                error: false,
            };
        case allotmentSummaryConstants.ALLOTMENT_SUMMARY_ERROR:
            return {
                getAllotmentSummaryLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/allotmentSummary/allotmentSummary.reducer.js